import { toast } from 'react-toastify';
import React from 'react';

export interface DesignatedResult {
  designated: boolean;
  hasError: boolean;
  errorMessage?: string;
}

export const getDisabledCellStyle = (isDisabled: boolean): React.CSSProperties => ({
  backgroundColor: 'transparent',
  opacity: isDisabled ? 0.5 : 1,
  color: isDisabled ? '#8d8d8d' : 'inherit',
  pointerEvents: isDisabled ? 'none' : 'auto',
  cursor: isDisabled ? 'not-allowed' : 'default',
});

export const parseFAQData = (doc: any): any => {
  if (doc.data && typeof doc.data === 'string') {
    try {
      const parsedData: any = JSON.parse(doc.data);

      return { ...doc, ...parsedData };
    } catch {
      return doc;
    }
  }

  return doc;
};

export const calculateDesignatedStatus = (
  userSuites: any[] | undefined
): DesignatedResult => {
  if (!userSuites || userSuites.length === 0) {
    return {
      designated: false,
      hasError: false,
    };
  }

  const designatedValues = userSuites.map((suite) => suite.designated);
  const uniqueValues = [...new Set(designatedValues)];

  // Check for mixed values (should not happen per business rule)
  if (uniqueValues.length > 1) {
    console.error(
      'Mixed designated values detected in userSuites:',
      userSuites
    );
    return {
      designated: false,
      hasError: true,
      errorMessage:
        'Data integrity error: Mixed designated values found. All suites must have the same designated status.',
    };
  }

  // All values are the same, return the first one.
  return {
    designated: designatedValues[0] ?? false,
    hasError: false,
  };
};

// Enriches contact data with calculated designated flag before form initialization
export const enrichContactDataForEdit = (contactData: any): any => {
  const designatedResult: DesignatedResult = calculateDesignatedStatus(
    contactData.userSuites
  );

  if (designatedResult.hasError) {
    console.error(designatedResult.errorMessage);

    toast.error(designatedResult.errorMessage, {
      autoClose: 8000,
      position: 'top-center',
    });
  }

  return {
    ...contactData,
    designated: designatedResult.designated,
  };
};
